import { getActiveSendMenu, setActiveSendMenu, getActiveMenu, setActiveMenu } from '../../utils/currentState'
const state = {
  activeMenu: getActiveMenu(),
  activeSendMenu: getActiveSendMenu()
}

const getters = {
  getActiveMenu (state) {
    return state.activeMenu
  },
  getActiveSendMenu (state) {
    return state.activeSendMenu
  }
}

const mutations = {
  SET_ACTIVEMENU: (state, info) => {
    state.activeMenu = info
  },
  SET_ACTIVESENDMENU: (state, info) => {
    state.activeSendMenu = info
  }
}

const actions = {
  SetActiveMenu ({ commit }, info) {
    commit('SET_ACTIVEMENU', info.activeMenu)
    commit('SET_ACTIVESENDMENU', info.activeSendMenu)
    setActiveMenu(info.activeMenu)
    setActiveSendMenu(info.activeSendMenu)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
